(function () {
  function hasDangerousItems() {
    return document.querySelector('[data-dangerous-item]') !== null;
  }

  // Keeps the cart attribute in sync so a Shopify Delivery Customization
  // Function can read `requires_pickup` and hide shipping rates at checkout.
  function syncCartAttribute() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { requires_pickup: hasDangerousItems() ? 'true' : '' }
      })
    }).catch(function () {});
  }

  // Expose for cart-drawer.js to call after renderContents updates the DOM.
  window.syncDangerousGoodsCartAttribute = syncCartAttribute;

  syncCartAttribute();

  // Re-sync after cart items re-render (Sections API replaces cart-items DOM)
  var cartItemsEl = document.querySelector('cart-items');
  if (cartItemsEl) {
    new MutationObserver(syncCartAttribute).observe(cartItemsEl, {
      childList: true,
      subtree: false
    });
  }
})();
